module.exports = __webpack_public_path__ + "static/media/employee-registration-db-bg.45dac1a1.svg";